var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGridView || _vm.isCollapsed)?_c('grid-view',{attrs:{"isReadView":_vm.isReadView}}):(_vm.isCardView)?_c('card-view-container'):(_vm.isDetailView)?_c('detail-view-container'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }